import { userInfo } from "os";

import Cookies from 'js-cookie';

const TokenKey = 'xToken';

export default {
  setCookie: function (name, value,expDays) {
    Cookies.set(name, value, { expires:expDays==undefined? 7: expDays});
  },

  getCookie(name){
    return Cookies.get(name);
  },

  //删除cookie
  delCookie (name) {
    Cookies.remove(name)
  },


  //删除cookie
  delCookie (cname) {
    Cookies.remove(cname)
  },


  getToken() {
    //console.log(Cookies.get(TokenKey))
    return sessionStorage.getItem(TokenKey);//Cookies.get(TokenKey)
  },
  setToken(token) {
    return sessionStorage.setItem(TokenKey, token);//Cookies.set(TokenKey, token)
  },
  removeToken() {
    return sessionStorage.removeItem(TokenKey);//Cookies.remove(TokenKey)
  }

}



// WEBPACK FOOTER //
// ./src/common/utils/token.js